import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { ISettingEntry } from "@faire/web-api--source/indigofair/settings/ISettingEntry";
import { setting } from "./setting";
export function featureToggle(schema) {
    var _schema_defaultValue;
    return setting(_object_spread({
        type: ISettingEntry.SettingType.FEATURE_TOGGLE,
        defaultValue: (_schema_defaultValue = schema.defaultValue) !== null && _schema_defaultValue !== void 0 ? _schema_defaultValue : false
    }, schema));
}
